<template>
  <div class="wrapper-section-reviews">
    <h2 class="subtitle-reviews">{{ $t('search.reviews.title') }}</h2>

    <div class="reviews-grid">
      <div v-for="review in reviews" :key="review.uuid" class="review-card">
        <div class="review-header">
          <img
            :src="review._user.profile.avatar.src"
            :alt="review._user.profile.fullname"
          />
          <span class="review-author">{{ review._user.profile.fullname }}</span>
        </div>
        <el-rate v-model="review.score" disabled />
        <p class="review-text">{{ review.message }}</p>
        <el-button type="text" size="mini" class="show-more" @click="showMore">
          {{ $t(`general.show_more`) }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadSearchReviews',
  props: {
    limit: { type: Number, default: 4 },
  },
  computed: {
    ...mapState('country', {
      reviews(state) {
        return state.reviews.slice(0, this.limit)
      },
    }),
  },
  mounted() {
    // Obtener los elementos a procesar
    const items = document.querySelectorAll('p.review-text')

    // Filtrar solo los truncados
    const truncatedItems = [...items].filter(
      (p) => p.offsetHeight < p.scrollHeight
    )

    // Agregar atributo a los truncados
    truncatedItems.forEach((item) => item.setAttribute('data-truncated', ''))
  },
  methods: {
    showMore(event) {
      const p = event.target.parentNode.previousElementSibling
      if (p) {
        p.removeAttribute('data-truncated')
        p.classList.add('show-all')
      }
    },
  },
}
</script>

<style lang="scss">
.wrapper-section-reviews {
  .subtitle-reviews {
    font-size: 48px;
    font-weight: 700;
    text-align: center;
  }

  .reviews-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }

  .review-card {
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    flex: 1;

    img {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      object-fit: cover;
    }
  }

  .review-author {
    font-size: 14px;
    font-weight: 700;
  }

  .review-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 5px;
  }

  .el-rate__icon {
    margin: 0;
  }

  .show-more {
    display: none;
    float: right;
    padding: 0;

    & > span {
      padding: 7px 0;
      display: inline-block;
    }
  }

  .review-text {
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-style: italic;

    &[data-truncated] + .show-more {
      display: inline;
    }

    &.show-all {
      display: inline-block;
    }
  }

  @media screen and (max-width: 1026px) {
    .review-card {
      flex: 0 0 48%;
    }
  }

  @media screen and (max-width: 768px) {
    .subtitle-reviews {
      font-size: 24px;
      width: 90%;
      margin-left: auto;
      margin-right: auto;
    }

    .review-card {
      flex: 0 0 100%;
    }

    .reviews-grid {
      padding: 10px 20px;
    }
  }
}
</style>
